import request from '../request'

const userApi = {
    getUserInfo: (query) => request.get(`/user/profile${query}`),
    updateUserInfo: (id, payload) => request.patch(`/users/${id}`, payload),
    updateUserPassword: (id, payload) => request.patch(`/users/${id}/password`, payload),
    updateUser: (id, payload) => request.patch(`/users/${id}`, payload),
    ignoreUpdatePassword: (id) => request.patch(`/users/${id}/ignore-password`),
    uploadAvatarUser: (id, payload) => request.post(`/users/${id}/avatar`, payload, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    }),
    gatewayRefreshToken:(payload) => request.patch(`gateway-refresh-token`, payload),

}
export default userApi;
